import { EntityType } from '@repo/common/enums/entityType';

// Keep this in sync with the `CATALOG_ENTITY_TYPES` in `api/catalog/constants.py`
export const CATALOG_ENTITY_TYPES = [
	EntityType.table,
	EntityType.column,
	EntityType.dashboard,
	EntityType.chart,
	EntityType.job,
	EntityType.event,
	EntityType.schema,
	EntityType.database,
	EntityType.dashboard_group,
	EntityType.job_group,
	EntityType.category,
	EntityType.generic,
	EntityType.generic_group,
];

// Keep this in sync with the `ALWAYS_PUBLISHED_ENTITIES` in `api/contrib/constants.py`
export const ALWAYS_PUBLISHED_ENTITIES = [
	EntityType.database,
	EntityType.schema,
	EntityType.dashboard_group,
	EntityType.job_group,
];
